import {Component} from "react";
import {Button, ButtonGroup, Form, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import AppCpeCveIcon from "../../../media/app-images/AppCpeCveIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";
import CloseIcon from "../../../media/images/CloseIcon.mjs";
import CheckIcon from "../../../media/images/CheckIcon.mjs";
import AppReloadIcon from "../../../media/app-images/AppReloadIcon.mjs";

const prefix='CveLoaderFilterModal';

const CveLoaderFilterModal = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			info: props.info,
			filter: {}
		}
		this.filterValue = this.filterValue.bind(this);
	}
	filterValue( e ) {
		const fieldName = e.target.name;
		const fieldValue = (e.target.value||'').replace(/[^0-9]/g, '');
		const f = this.state.filter;
		f[fieldName] = fieldValue;
		const changed = !!(f.year + f.num);
		this.setState( { filter: f, changed: changed }, ()=>{
			this.setState( { info: this.props.filter(changed ? f : false ) } );
		});
	}
	render() {
		return (
			<Modal
				className={prefix}
				isOpen={true}
				fade={false}
				toggle={this.props.close}
				onOpened={appLib.modalAutoFocus}
			>
				<ModalHeader toggle={this.props.close}>
					<AppCpeCveIcon />
					<TextLabel value={"Filter"} />
				</ModalHeader>
				<ModalBody>
					<ul>
						<li>
							<TextLabel value={"CVE"} />: <strong>{ this.state.info.count.toLocaleString( this.state.ll) }</strong>
						</li>
						<li>
							<TextLabel value={"Total size"} />: <strong>{ this.state.info.totalSize.toLocaleString( this.state.ll) }</strong> B
						</li>
					</ul>
					<hr />
					<Form
						onSubmit={ e => e.preventDefault() }
					>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Year"} />:
								</Label>
							</InputGroupText>
							<Input
								name={"year"}
								value={this.state.filter?.year || ''}
								onChange={ this.filterValue }
							/>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Number"} />:
								</Label>
							</InputGroupText>
							<Input
								name={"num"}
								value={this.state.filter?.num || ''}
								onChange={ this.filterValue }
							/>
						</InputGroup>
					</Form>
				</ModalBody>
				<ModalFooter>
					<ButtonGroup className={"btn-icon"}>
						<Button
							color={"warning"}
							onClick={ this.props.close }
						>
							<i>
								<CloseIcon />
							</i>
							<b>
								<TextLabel value={"Cancel"} />
							</b>
						</Button>
						<Button
							disabled={ ! this.state.changed }
							color={"warning"}
							onClick={ ()=>{
								this.setState( { filter: {}, changed: false, info: this.props.filter() } );
							}}
						>
							<b>
								<TextLabel value={"Reset"} />
							</b>
							<i>
								<AppReloadIcon />
							</i>
						</Button>
					</ButtonGroup>
					<ButtonGroup className={"btn-icon"}>
						<Button
							disabled={! this.state.changed}
							color={"success"}
							onClick={ ()=>{
								this.setState({
									filter: {},
									changed: false,
									info: this.props.filter( this.state.filter, true )
								}, this.props.close );
							}}
						>
							<b>
								<TextLabel value={"Save"} />
							</b>
							<i>
								<CheckIcon />
							</i>
						</Button>
					</ButtonGroup>
				</ModalFooter>
			</Modal>
		)
	}
}

export default CveLoaderFilterModal;